<template>
  <div id="id-understand-container">
    <img class="top-img" src="https://oss.pyamc.com/aboutApp/aboutHeader.png" alt="" />

    <section class="section-slogan">
      <ul>
        <li
        v-for="(item, index) in sectionData"
        :key="index"
        style="margin:0 0.4rem 1rem 0.4rem; border-radius:0.3rem;background:#fff;padding-top:0.1rem"
        >
          <img :src='item.imgUrl' style="margin:-0.65rem 0 0 0;height:1rem" alt="" />

          <div style="padding-top:0.6rem;padding-bottom:0.3rem ">
            <h2>{{ item.title }}</h2>
            <span>{{ item.text }}</span>
          </div>
        </li>
      </ul>
    </section>

    <section class="section-culture">
      <img :src="cultureData.imgUrl" alt="" />
      <div>
        <ul>
          <li v-for="(item, index) in cultureData.children" :key="index">
            <h2>{{ item.title }}</h2>
            <span>{{ item.text }}</span>
          </li>
        </ul>
      </div>
    </section>

    <section class="section-honor">
      <div class="section-honor-box">
        <img class="img-title" src="../../assets/img/所获荣誉@2x.png" alt="" />
        <div class="section-honor-item">
          <img
            class="section-honor-item-img"
            src="../../assets/img/中国证券报@2x.png"
            alt=""
          />
          <ul>
            <li v-for="(item, index) in honorData1" :key="index">
              <div class="circle"></div>
              <div
                class="line"
                :class="{
                  'v-h': index + 1 === honorData1.length,
                }"
              ></div>
              <div class="section-honor-item-content">
                <h3>{{ item.title }}</h3>
                <span>{{ item.text }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="section-honor-item">
          <img
            class="section-honor-item-img"
            src="../../assets/img/中国基金报@2x.png"
            alt=""
          />
          <ul>
            <li v-for="(item, index) in honorData1" :key="index">
              <div class="circle"></div>
              <div
                class="line"
                :class="{
                  'v-h': index + 1 === honorData1.length,
                }"
              ></div>
              <div class="section-honor-item-content">
                <h3>{{ item.title }}</h3>
                <span>{{ item.text }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="section-honor-box">
        <div class="section-honor-item section-honor-item-2">
          <div class="section-honor-item-title">
            <img
              class="section-honor-item-title-img"
              src="../../assets/img/中国金融期货交易所@2x.png"
              alt=""
            />
            <h2>中国金融期货交易所</h2>
          </div>
          <ul>
            <li v-for="(item, index) in honorData2" :key="index">
              <div class="circle"></div>
              <div class="line" style="height: 1.067rem"></div>
              <div class="section-honor-item-content">
                <h3>{{ item.title }}</h3>
                <span
                  style="
                    color: #d19f68;
                    font-size: 0.32rem;
                    line-height: 0.48rem;
                  "
                  >{{ item.text }}</span
                >
              </div>
            </li>
          </ul>
        </div>
        <div
          class="section-honor-item section-honor-item-2"
          style="margin-top: 0.667rem"
        >
          <div class="section-honor-item-title">
            <img
              class="section-honor-item-title-img"
              src="../../assets/img/证券时报@2x.png"
              alt=""
            />
            <h2>证券时报</h2>
          </div>
          <ul>
            <li v-for="(item, index) in honorData3" :key="index">
              <div class="circle"></div>
              <div
                class="line"
                :class="{
                  'v-h': index + 1 === honorData3.length,
                }"
              ></div>
              <div class="section-honor-item-content">
                <h3>{{ item.title }}</h3>
                <span>{{ item.text }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="section-honor-item section-honor-item-2">
          <div class="section-honor-item-title">
            <img
              class="section-honor-item-title-img"
              src="../../assets/img/路透社@2x.png"
              alt=""
            />
            <h2>REUTERS(路透社)</h2>
          </div>
          <ul>
            <li v-for="(item, index) in honorData4" :key="index">
              <div class="circle"></div>
              <div
                class="line"
                :class="{
                  'v-h': index + 1 === honorData4.length,
                }"
              ></div>
              <div class="section-honor-item-content">
                <h3>{{ item.title }}</h3>
                <span>{{ item.text }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      qqqq:require("../../assets/1111.png"),
      sectionData: [
        {
          title: "全国首家“私转公”基金公司",
          text: "2016年7月6日经中国证监会批准成立全国性公募基金管理有限公司，注册资本1.18亿元。",
          imgUrl: "https://oss.pyamc.com/aboutApp/company_grow.png",
        },
        {
          title: "资管总规模超1340亿元",
          text: "截止2022年一季度末，在优异业绩带动下，鹏扬基金成立5年，管理资产总规模达到1343亿元，为百万投资者创造了逾百亿元利润（数据来源：鹏扬基金）。",
          imgUrl: "https://oss.pyamc.com/aboutApp/fund_scale.png",
        },
        {
          title: "主动权益类基金排名行业第5",
          text: "截止2022年3月31日，鹏扬主动权益基金的近3年平均收益为129.12%，排名行业第5（数据来源：海通证券）。",
          imgUrl: "https://oss.pyamc.com/aboutApp/stock_rank.png",
        },
        {
          title: "“固收+”基金位居行业第12",
          text: "2021年四季度末“固收+”基金规模460亿元，位居行业第12。在近年信用违约风潮下，鹏扬基金风险管理能力赢得行业尊敬，实现旗下产品零踩雷，无持仓债券评级下调（数据来源：wind）。",
          imgUrl: "https://oss.pyamc.com/aboutApp/fund_rank.png",
        },
        // {
        //   title: '总经理杨爱斌拥有22年资管经验',
        //   text: '总经理杨爱斌在债券投资领域极具影响力、拥有22年深厚的投资经验。曾被中国基金报评选为“中国基金业20年最佳基金经理”，曾多次荣获金牛奖。',
        //   imgUrl: 'https://oss.pyamc.com/aboutApp/manager_qualification.png'
        // }
      ],
      cultureData: {
        imgUrl: "https://oss.pyamc.com/aboutApp/corporate_culture.png",
        children: [
          {
            title: "愿景",
            text: "成为资本市场上有影响力的、持续为客户创造价值的资产管理公司！",
          },
          {
            title: "使命",
            text: "为客户创造价值，为美好生活助力",
          },
          {
            title: "经营宗旨",
            text: "专业稳健 回报信任",
          },
          {
            title: "价值观",
            text: "客户至上 勇于担当 拥抱变化 合作共赢",
          },
        ],
      },
      honorData1: [
        {
          title: "开放式债券型金牛基金",
          text: "2018年度，鹏扬汇利债券基金",
        },
        {
          title: "金牛特别贡献奖",
          text: "2016年度，鹏扬基金",
        },
        {
          title: "金牛私募管理公司（债券策略）",
          text: "2014、2015年度，鹏扬投资",
        },
      ],
      honorData2: [
        {
          title: "国债期货优秀交易团队奖(资管类)",
          text: "2016、2017、2018年度，鹏扬基金是唯一连续3年荣获该奖项的公募基金公司",
        },
      ],
      honorData3: [
        {
          title: "明星基金公司成长奖",
          text: "2018年度，鹏扬基金",
        },
        {
          title: "积极债券型明星基金奖",
          text: "2018年度，鹏扬汇利债券基金",
        },
      ],
      honorData4: [
        {
          title: "路透社中国固定收益市场展望金融债奖第3名",
          text: "2017年度，鹏扬基金",
        },
        {
          title: "路透中国人民币市场展望金融债第1名、综合第5名",
          text: "2018年度，固定收益总监王华",
        },
        {
          title: "路透中国“人民币市场展望奖金融债第1名",
          text: "2018年度，固定收益总监王华",
        },
      ],
    };
  },
  mounted() {
    document.title = "了解鹏扬";
  },
  methods: {},
};
</script>
<style
  lang="scss"
  scoped
>
#id-understand-container {
  position: relative;
  width: 100%;
  //background-color: pink;
  .top-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -2;
  }

  .section-slogan {
    padding-top: 150px;
    /* //margin-top: 118px; */
    ul {
      li {
        position: relative;
        padding: 0 0.4rem;
        margin-bottom: 0.32rem;
        //background: url("../../assets/img/NO.1@2x.png");
        img {
          display: block;position:absolute
        }
        div {
          /* position: absolute; */
          display: flex;
          flex-direction: column;
          //padding-top: 48px;
          /* left: 0.8rem;
          top: 1.28rem; */
          width: 8.5rem;
          h2 {
            margin-bottom: 0.133rem;
            font-family: PingFangSC-Medium;
            font-size: 0.427rem;
            color: #222222;
            line-height: 0.64rem;
            font-weight: bold;
          }
          span {
            font-family: PingFangSC-Regular;
            font-size: 0.347rem;
            color: #666666;
            line-height: 0.533rem;
            font-weight: 400;
          }
        }
      }
    }
  }

  .section-culture {
    /* position: relative; */
    padding: 0 0.4rem;
    border-radius: 0.3rem;
    background: #fff;
    margin: 0 0.4rem 0.32rem 0.4rem;
    padding-top:0.1rem;
    img {
      /* width: 4rem; */
      height: 0.7rem;
      display: block;
      margin-top:-0.5rem;
    }
    div {
      /* position: absolute; */
      display: flex;
      flex-direction: column;
      /* left: 0.8rem;
      top: 1.28rem; */
      padding-top:0.3rem;
      width: 8.5rem;
      
      h2 {
        margin-top: 0.122rem;
        //margin-bottom: 0.133rem;
        font-family: PingFangSC-Medium;
        font-size: 0.427rem;
        color: #222222;
        line-height: 0.48rem;
        font-weight: bold;
      }
      span {
        margin-top: 0.21rem;
        margin-bottom: 0.25rem;
        font-family: PingFangSC-Regular;
        font-size: 0.347rem;
        color: #666666;
        line-height: 0.533rem;
        font-weight: 400;
        display: block;
      }
    }
  }

  .section-honor {
    padding: 0 0.4rem 0.64rem 0.4rem;
    //background-color: pink;
    .section-honor-box {
      padding: 0.533rem 0.4rem 0 0.4rem;
      //padding: 0.533rem 0.4rem;
      background-color: #fff;
      border-radius: 8px;
      .img-title {
        width: 2.667rem;
        height: 0.8rem;
        margin-bottom: 0.267rem;
      }
      .section-honor-item-title {
        display: flex;
        padding-left: 0.4rem;
        padding-bottom: 0.267rem;
        align-items: center;
        .section-honor-item-title-img {
          width: 0.427rem;
          height: 0.427rem;
        }
        h2 {
          margin-left: -0.2rem;
          font-family: PingFangSC-Regular;
          font-size: 0.32rem;
          color: #666666;
          line-height: 0.48rem;
          font-weight: 400;
        }
      }
      .section-honor-item {
        img {
          position: relative;
          left: -0.4rem;
          width: 3.307rem;
          height: 0.747rem;
        }
        ul {
          margin-top: 14px;
          li {
            position: relative;
            .circle {
              box-sizing: border-box;
              width: 0.213rem;
              height: 0.213rem;
              border-radius: 50%;
              border: 1px solid #dddddd;
            }
            .line {
              position: relative;
              left: 0.093rem;
              box-sizing: border-box;
              border-left: 1px dashed #dddddd;
              //width: 1px;
              height: 1.493rem;
            }
            .section-honor-item-content {
              display: flex;
              flex-direction: column;
              position: absolute;
              left: 0.613rem;
              top: -0.16rem;
              h3 {
                font-family: PingFangSC-Medium;
                font-size: 0.4rem;
                color: #222222;
                line-height: 0.587rem;
                font-weight: bold;
              }
              span {
                font-family: PingFangSC-Regular;
                font-size: 0.347rem;
                color: #999999;
                line-height: 0.533rem;
                font-weight: 400;
              }
            }
          }
        }
      }

      .section-honor-item.section-honor-item-2 {
        .section-honor-item-content {
          h3 {
            font-size: 0.347rem;
          }
          span {
            font-size: 0.32rem;
          }
        }
      }
    }
    .section-honor-box:nth-child(2) {
      margin-top: 0.32rem;
    }
  }

  .v-h {
    visibility: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/aboutApp.vue